<template>
  <div class="result-group">
    <div class="result-title-wrap">
      <h3 ref="SeeMoreTopRef">{{ title }}</h3>
      <p><span>{{ totalElements }}</span>건</p>
    </div>

    <ul v-if="results && results.length > 0" class="responsive-list">
      <transition-group name="fade">
        <SearchResultArticleCard
            v-for="item in results"
            :key="item.uuid"
            :uuid="item.uuid"
            :href="router.resolve({ name: routerName, params: { uuid: item.uuid } }).href"
            :imageUrl="item.previewImageUrl || item.imageUrl"
            :like-type="item.likeType"
            :is-like="item.isLike"
            :period-from="item.periodFrom"
            :period-to="item.periodTo"
            :highlight="item.highlight"
        />
      </transition-group>
    </ul>

    <SeeMoreButton
        :totalPages="totalPages"
        :currentPage="currentPage"
        :fetchItems="fetchSearchData"
        :itemRef="SeeMoreTopRef"
    />


  </div>
</template>

<script setup>
import {defineProps, onMounted, ref, watch} from "vue";
import {useRouter} from "vue-router";
import {apiClient} from "@/services/auth-header";
import SeeMoreButton from "@/components/ui/SeeMoreButton.vue";
import SearchResultArticleCard from "@/views/search/components/card/SearchResultArticleCard.vue";

const props = defineProps({
  query: {type: String, required: true},
  title: { type: String, required: true },
  indexName: { type: String, required: true},
  routerName: { type: String, required: true },
});

watch(
    () => props.query,
    (newQuery) => {
      fetchSearchData();
    }
)

const emit = defineEmits(['update:totalElements'])

const router = useRouter();
const results = ref(null);
const index = ref(props.indexName)
const currentPage = ref(0);
const size = ref(6);
const totalPages = ref(0);
const isFetching = ref(false);
const SeeMoreTopRef = ref(null);
const totalElements = ref(0);


const fetchSearchData = async (page = 0, append = false) => {
  if (isFetching.value) {
    return;
  }
  isFetching.value = true;

  try {
    const response = await apiClient.get(`/v1/search/unified-field/${index.value}?q=${props.query}&page=${page}&size=${size.value}`);
    const newData = response.data.content;
    // console.log(index.value," response.data ",response.data)
    if (append) {
      results.value.push(...newData);
    } else {
      results.value = newData;
    }
    totalElements.value = response.data.totalElements;
    currentPage.value = response.data.pageable.pageNumber;
    totalPages.value = response.data.totalPages;
    emit('update:totalElements', { key: 'ARTICLE', value: totalElements.value });
  } catch (error) {
    console.error("Error fetching result data:", error);
  } finally {
    isFetching.value = false;
  }
};

onMounted(async () => {
  //await fetchSearchData(currentPage.value);
});

</script>

<style scoped>



</style>